import { getAuthApi } from "swagger";

export const connectApi = (addr) => {
  return getAuthApi()
    .apiAuthUserNonceAddrGet({
      addr,
    })
    .then((res) => res.json());
};

export const loginApi = (body) => {
  return getAuthApi()
    .apiAuthUserLoginPost(body)
    .then((res) => res.json());
};
